import React from 'react';
import { useFormContext } from '../Provider';
import useValidators from '../Validators/useValidator';
import CommonFieldWrapper from './CommonFieldWrapper';
import Icon from '../../Icons/Icon';
import { MoneyValidator } from '..';
import { useConditionalHelper } from '../Conditional';
import { useFieldPanelHelper } from '../../Containers/Accordion/Panel';

const Money = ({label, name, help, onChange, suffix, disabled, validators}) => {
    const { formData, updateField, updateValidity, isValidating, isSubmitting, formDisabled } = useFormContext();
    const value = formData[name] ?? 0;
    const {isValid, error} = useValidators(value, validators, name, updateValidity, [MoneyValidator]);

    useConditionalHelper(name);
    useFieldPanelHelper(name, value, isValid);

    const handleChange = (e) => {
        const int = parseInt(e.target.value.replace(/[^0-9]*/g, ''))
        updateField(name, int);
        onChange && onChange(int);
    }

    const isDisabled = formDisabled || disabled || isSubmitting;

    return <CommonFieldWrapper {...{label, name, help, value, isValid, isValidating, error, validators, isDisabled}}>

        <div className="relative flex flex-row">
            <div className="pointer-events-none inset-y-0 left-0 flex items-center pr-1 fill-gray-400">
                <Icon icon="SterlingSign" size="0.5x" inline />
            </div>

            <input className="ml-1 block w-full border-0 p-0 text-gray-900 placeholder:text-gray-400 focus:ring-0 sm:text-sm sm:leading-6 disabled:text-gray-400 disabled:bg-gray-100"
                type="number"
                value={value ? (value/100).toFixed(2) : ''}
                onChange={handleChange}
                placeholder={"0.00"}
                disabled={isDisabled}
            />

            <div className="pointer-events-none inset-y-0 right-0 flex items-center pl-1">
                <span className="fill-gray-400 text-gray-400 sm:text-sm">{suffix}</span>
            </div>
        </div>

    </CommonFieldWrapper>
}

export default Money;
